import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import TenantConfig from "../../models/tenant/tentantConfig.model";

const initialState: TenantConfig = {
  configCarregada: false,
  digitarCliente: false,
  aprovaCliente: false,
  exibePrecoBrutoPdf: true,
  grade: {
    nomeGrade2: "",
    nomeGrade3: "",
    somenteNumerico: true,
    tamanhoMaximoGrade2: 6,
    tamanhoMaximoGrade3: 2,
  },
  pedidoVenda: {
    aceitaItemDuplicado: false,
    ocultarDesconto: false,
    tipoPedidoPadraoId: "",
    tabelaPrecoPadraoId: "",
    condicaoPagamentoPadraoId: "",
    preenchePrevisaoAuto: false,
    criticaDescontoCond: true,
    situacaoPedidoInicial: "",
    ocultarProdutoSemSaldo: true,
    ocultarQuantidadeTotal: false,
    aceitaMultiplasCondicoesPagamento: true,
  },
  cadastroCliente: {
    campos: {},
    permiteEdicao: true,
    permiteCadastro: true,
    verTodosClientes: false,
  },
  cadastroProduto: {
    campos: {},
  },
  nomeSistemaIntegrado: "",
  listaProduto: {
    ocultarProdutoSemSaldo: true,
  },
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantConfig(state: TenantConfig, action: PayloadAction<TenantConfig>) {
      state.configCarregada = true;
      state.digitarCliente = action.payload?.digitarCliente ?? false;
      state.aprovaCliente = action.payload?.aprovaCliente ?? false;
      state.exibePrecoBrutoPdf =
        action.payload?.exibePrecoBrutoPdf ?? state.exibePrecoBrutoPdf ?? true;
      state.cadastroCliente = {
        ...state.cadastroCliente,
        ...action.payload?.cadastroCliente,
      };
      state.cadastroProduto = {
        ...state.cadastroProduto,
        ...action.payload?.cadastroProduto,
      };
      state.grade = { ...state.grade, ...action.payload?.grade };
      state.nomeSistemaIntegrado =
        action.payload?.nomeSistemaIntegrado || state.nomeSistemaIntegrado;
      state.pedidoVenda = {
        ...state.pedidoVenda,
        ...action.payload?.pedidoVenda,
      };
      state.listaProduto = {
        ocultarProdutoSemSaldo:
          action.payload?.listaProduto?.ocultarProdutoSemSaldo ??
          state.listaProduto?.ocultarProdutoSemSaldo ??
          true,
      };
    },
  },
});

export const tenantActions = tenantSlice.actions;

export default tenantSlice;
